import React from "react";
import "../Styles/SliderArea.css";
import "../assets/css/swiper-bundle.css";
import "../assets/css/custom-animation.css";
import "../assets/css/animate.min.css";
// import videoBack from "../assets/All Images/banner_back.mp4";
import videoBack2 from "../newimgs/Home Page Image.png";
// import mainBanner from "../assets/All Images/main-banner1.jpg";
import config from "../config";
import { Link } from "react-router-dom";

const SliderArea = () => {
  return (
    <div>
      <section className="bd-slider-area">
        <div className="bd-slider-active swiper-container">
          <div>
            <div className="bd-single-slider bd-single-slider-overlay bd-slider-height d-flex align-items-center swiper-slide jus" >
              <div className="bd-slide-bg"
               style={{ opacity: "0.22" }}
               >
                {/* <video
                  src="https://res.cloudinary.com/ztpl-images/video/upload/q_auto,f_auto/v1659439415/website/home/zithas-intro-10500_ghzqha.mp4"
                  src={videoBack}
                  autoPlay
                  loop
                  playsInline
                  muted
                ></video> */}
                <img
                style={{height:"100%",width:"100%"}}
                src={videoBack2}
                />
                {/* <video src={video} autoPlay loop playsInline muted></video> */}
                {/* <img
                  src={mainBanner}
                  className="resp-img bordertop-img1"
                  alt="img not found"
                /> */}
              </div>
              <div className="container pt-55">
                <div className="row cont-title d-flex justify-content-center align-items-center">
                  <div className="col-12 ">
                    <div className="bd-slider z-index text-center pt-35 homeSlider">
                      <h1
                        className="bd-slider-title mb-20 banner-title"
                        data-animation="fadeInUp"
                        data-delay=".3s"
                        
                      >
                        Strategic Consulting for a Digital Future
                      </h1>
                      <p
                        className="mb-10 banner-title-p"
                        data-animation="fadeInUp"
                        data-delay=".6s"
                      >
                        Digital technology already shapes every aspect of our
                        lives at home and at work. <br/>Embracing it is essential to
                        thrive in a world defined by constant innovation.{" "}
                      </p>

                      <p
                        className="mb-40 banner-title-p"
                        data-animation="fadeInUp"
                        data-delay=".6s"
                      >
                        Ambrella helps enterprises transform their digital
                        <b> "Ambitions to Reality"</b>
                      </p>
                      <div
                        className="bd-slider-btn "
                        data-animation="fadeInUp"
                        data-delay=".9s"
                      >
                        {/* <Link
                          to={"/about-us"}
                          className="theme-btn mr-2 themebtn2-1"
                        >
                          Let us talk
                        </Link> */}
                        <Link to={`${config.appurl}services`} className="theme-btn">
                          Explore Services
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SliderArea;
